import React, { useState, useRef, useEffect } from 'react';

// Components
import Icon from 'shared/components/Icon';

// Icons
import ArrowDownIcon from 'command/assets/arrow-down.svg';

// Styles
import './styles.scss';

const LandingPageDropdownButton = (props) => {
  const { text = '', items = [], textIcon } = props;
  const [showDropdownContent, setShowDropdownContent] = useState(false);
  const [clickedOutside, setClickedOutside] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick, true);
    return () => {
      document.removeEventListener('click', handleOutsideClick, true);
    };
  }, []);

  const handleOutsideClick = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setClickedOutside(false);
      setShowDropdownContent(false);
    } else {
      setClickedOutside(true);
    }
  };

  const toggleDropDownContent = () => setShowDropdownContent((val) => !val);

  return (
    <div className="landing-page-dropdown">
      <div
        className="landing-page-dropdown-btn"
        onClick={() => {
          if (!showDropdownContent) toggleDropDownContent();
        }}
      >
        <div className="dropdown-title">
          <div>
            {textIcon && <Icon icon={textIcon} />} &nbsp; {text}
          </div>
          {<Icon icon={ArrowDownIcon} />}
        </div>
      </div>
      {showDropdownContent && clickedOutside && (
        <div className="dropdown-content" ref={ref}>
          {items.map((item, key) => (
            <div
              className="dropdown-content-item"
              key={key}
              onClick={() => {
                toggleDropDownContent();
                item?.action();
              }}
            >
              {item?.icon && <Icon icon={item.icon} />}{' '}
              <span>{item.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LandingPageDropdownButton;
